/**
 * Created by yongkai on 2022/08/19.
 * 通用工具类
 */

/**
 * 全局业务appId
 * paas应用id saas业务线 生产环境: '15df4d3f', 测试环境: 'fd8d3653'
 */
// export const bu_appId = {
//   test_new: 'f14ed109',
//   test: 'fd8d3653',
//   production: '15df4d3f',
//   production_pls: 'lMtz4Bzo'
// };

/**
 * 宣传的视频
 * paas回放在控制台指定死的产品定义的固定宣传视频回放id
 *
 */
export const paas_record_id_propagandaVideo = {
  test: '48b500e0',
  production: 'd57f42f4'
};
